export const en = {
  // App branding
  appName: 'Hekaya',
  
  // Navigation
  home: 'Home',
  forYou: 'For you',
  myList: 'My list',
  profile: 'Profile',
  userProfile: 'User Profile',
  
  // Authentication
  signIn: 'Sign In',
  signUp: 'Sign Up',
  signOut: 'Sign out',
  signInWithApple: 'Sign in with Apple',
  signUpWithApple: 'Sign up with Apple',
  signInWithGoogle: 'Sign in with Google',
  signUpWithGoogle: 'Sign up with Google',
  appleSignInFailed: 'Apple Sign In failed. Please try again.',
  appleAuthExpired: 'Apple code expired',
  appleAuthRetrying: 'Retrying automatically...',
  appleAuthRetryFailed: 'Apple Sign In failed. Please try again.',
  appleAuthMaxRetriesReached: 'Too many attempts. Please try again later.',
  appleSignInCancelled: 'Apple Sign In was cancelled.',
  appleAccountAlreadyExists: 'An account with this Apple ID already exists. Please sign in instead.',
  appleAccountNotFound: 'No account found with this Apple ID. Please sign up first.',
  googleSignInFailed: 'Google Sign In failed. Please try again.',
  googleAuthRetrying: 'Retrying automatically...',
  googleAuthMaxRetriesReached: 'Too many attempts. Please try again later.',
  or: 'or',
  email: 'Email',
  emailOrPhone: 'Email or Phone',
  enterEmail: 'Enter your email',
  enterEmailOrPhone: 'Enter your email or phone number',
  emailOrPhonePlaceholder: 'email@example.com or +33612345678',
  signInRequired: 'Sign in required',
  toWatchThisEpisode: 'To watch this episode',
  toAddEpisodeToFavorites: 'To add this episode to your favorites',
  pleaseSignInToWatch: 'Please sign in to watch this episode',
  pleaseSignInToAddFavorite: 'Please sign in to add this episode to favorites',
  pleaseSignInToAddSerieFavorite: 'Please sign in to add this series to favorites',
  pleaseSignInToSubscribe: 'Please sign in to subscribe',
  pleaseSignInToAccessRewards: 'Please sign in to access all features and track your rewards.',
  subscriptionRequired: 'Subscription required',
  episodeRequiresPremium: 'This episode requires a premium subscription',

  // Force update
  updateRequired: 'Update Required',
  currentVersion: 'Current version',
  requiredVersion: 'Required version',
  updateNow: 'Update now',
  appCannotBeUsedWithoutUpdate: 'The app cannot be used without updating',
  forceUpdateDefaultMessage: 'A new version of the app is available. Please update to continue using the app.',

  // Recommended update
  updateAvailable: 'Update Available',
  recommendedVersion: 'Recommended version',
  updateButton: 'Update',
  laterButton: 'Later',
  updateWillBeShownAgainIn24Hours: 'This update will be shown again in 24 hours',
  recommendedUpdateMessage: 'A new version of the app is available with improvements and new features. We recommend updating for the best experience.',

  // Errors
  error: 'Error',
  pleaseFillAllFields: 'Please fill in all fields',
  failedToCreateAccount: 'Failed to create account',
  invalidCredentials: 'Invalid credentials',
  accountDisabled: 'This account has been disabled',
  emailAlreadyExists: 'This email is already in use by another account',
  phoneAlreadyExists: 'This phone number is already in use by another account',
  invalidEmailFormat: 'Please enter a valid email address',
  invalidPhoneFormat: 'Please enter a valid phone number',
  accountMergeNotSupported: 'An account already exists with this email address. Please sign in using your original login method.',

  // Content
  searchDramas: 'Search dramas...',
  noResultsFound: 'No results found for "{query}"',
  searchResultsOne: '1 result for "{query}"',
  searchResultsMany: '{count} results for "{query}"',
  allSeries: 'All Series',
  topCharts: 'Top Charts',
  recommendedForYou: 'Recommended for you',
  basedOnPreferences: 'Based on your preferences',
  continueWatching: 'Continue Watching',
  resumeWatching: 'Resume Watching',
  similarToWatched: 'Similar to what you watched',
  trendingSearches: 'Trending Searches',
  noSeriesInProgress: 'No series in progress',
  startWatchingToSee: 'Start watching a series to see it here',
  noContentAvailable: 'No content available',
  checkSupabaseConfig: 'Please check your Supabase configuration',
  
  // Series and episodes
  seasons: 'Seasons',
  season: 'Season',
  episodes: 'Episodes',
  synopsis: 'Synopsis',
  episode: 'Episode',
  play: 'Play',
  swipeToSeeMore: 'Swipe to see more',
  myListAction: 'My List',
  addToMyList: 'Add to favorites',
  removeFromMyList: 'Remove from favorites',
  popular: 'Popular',
  new: 'New',
  trending: 'Trending',
  highlight: 'Highlight',
  free: 'Free',
  premium: 'Premium',
  premiumEpisode: 'Premium Episode',
  signInToUnlock: 'Sign in to unlock',
  subscribeToWatch: 'Subscribe to watch',
  
  // Profile
  subscribeToPremium: 'Upgrade to Premium',
  subscribeWithDCB: 'Upgrade to Premium with DCB',
  dcbSubscribeModalTitle: 'Mobile payment subscription',
  dcbSubscribeLoading: 'Preparing payment...',
  dcbSubscribeError: 'Unable to load the payment page.',
  dcbSubscribeRetry: 'Retry',
  restorePurchases: 'Restore Purchases',
  purchaseProcessing: 'Processing...',
  subscriptionActivated: 'Subscription activated successfully!',
  webPaymentUnavailable: 'Web payments are currently unavailable. Please try again later.',
  paymentInitializing: 'Payment system is still initializing. Please try again in a few seconds.',
  loadingOffers: 'Loading offers...',
  purchasesRestored: 'Your subscription has been successfully restored! You now have access to all premium content.',
  noPurchasesToRestore: 'No active subscriptions were found to restore. If you believe this is an error, please contact support.',
  purchaseFailed: 'Purchase failed. Please try again.',
  restoreFailed: 'Failed to restore purchases.',
  restoreNetworkError: 'Connection problem. Please check your internet connection and try again.',
  restoreReceiptInUse: 'This store account is already linked to another profile. Sign in with the original account to use this subscription.',
  noActiveSubscription: 'No active subscription found to restore.',
  iapNotAvailable: 'In-app purchases are not available.',
  webPurchaseNotSupported: 'In-app purchases are not available on web. Please use the mobile app.',

  // Premium subscription paywall
  premiumSubscriptionTitle: 'Premium Monthly Subscription',
  premiumSubscriptionTagline: 'Unlock unlimited access to all drama series and episodes',
  whatYouGet: 'What You Get',

  // Profile subscription information
  profileSubscriptionDescription: 'Get unlimited access to all drama series and episodes with our monthly subscription.',
  profileBenefit1: 'Watch any episode from our full library',
  profileBenefit2: 'Instant access to all new episodes',
  profileBenefit3: 'Ad-free viewing experience',

  premiumBenefit1: 'Unlimited access to all drama series - watch any episode, any time',
  premiumBenefit2: 'Full library of current content with hundreds of episodes',
  premiumBenefit3: 'Instant access to all new episodes as they release',
  premiumBenefit4: 'Watch any episode without restrictions or limitations',
  premiumBenefit5: 'Ad-free viewing experience for uninterrupted entertainment',
  premiumBenefit6: 'High-quality video streaming for the best viewing experience',
  premiumBenefit7: 'Access across all your devices - phone, tablet, and web',
  bestValue: 'Best Value',
  subscriptionIncludes: 'Full access to all content',
  perMonth: '/month',
  perWeek: '/week',
  startSubscription: 'Start Subscription',
  learnMoreAboutSubscription: 'Learn More About Subscription',

  // Subscription terms
  subscriptionTerms: 'You will be charged through your account at the price displayed on the subscription screen. The subscription auto-renews monthly unless you cancel it at least 24 hours before the renewal date. Charges are made 24 hours before the end of your current billing period.',

  // Subscription details modal
  subscriptionDetails: 'Subscription Details',
  whatIsIncluded: 'What Is Included',
  subscriptionDetailsDescription: 'Your Premium Monthly Subscription gives you unlimited access to all drama series and episodes in our library. This includes all current content and all new episodes that are released during your subscription period. You can watch any episode, any time, on any of your devices without restrictions.',
  howBillingWorks: 'How Billing Works',
  billingDescription: 'You will be charged through your account at the price shown on the subscription screen. The subscription automatically renews each month unless you cancel it at least 24 hours before the renewal date. Charges occur 24 hours before the end of your current billing period.',
  howToCancel: 'How To Cancel',
  cancellationDescription: 'You can cancel your subscription at any time by going to your device settings. For iOS: Settings > [Your Name] > Subscriptions. For Android: Google Play Store > Menu > Subscriptions. Select this app and tap Cancel Subscription. Your subscription remains active until the end of the current billing period.',
  cancellationDescriptionIos: 'You can cancel your subscription at any time by going to your device settings. For iOS: Settings > [Your Name] > Subscriptions. Select this app and tap Cancel Subscription. Your subscription remains active until the end of the current billing period.',
  cancellationDescriptionAndroid: 'You can cancel your subscription at any time by going to your device settings. For Android: Google Play Store > Menu > Subscriptions. Select this app and tap Cancel Subscription. Your subscription remains active until the end of the current billing period.',
  subscriptionExpiry: 'What Happens When Subscription Expires',
  expiryDescription: 'If you cancel or your subscription expires, you will lose access to premium content. However, your viewing history and favorites will be saved. You can resubscribe at any time to regain full access to all premium episodes.',
  deviceCompatibility: 'Device Compatibility',
  compatibilityDescription: 'Your subscription works across all platforms where you use the same account. Sign in with the same account on any device to access your premium benefits.',
  helpFeedback: 'Help & feedback',
  language: 'Language',
  notifications: 'Notifications',
  notificationSettings: 'Notification Settings',
  pushNotifications: 'Push Notifications',
  enabled: 'Enabled',
  disabled: 'Disabled',
  enable: 'Enable',
  enabling: 'Enabling...',
  pushNotificationsEnabled: 'Push notifications enabled successfully',
  pushNotificationsDisabled: 'Push Notifications Disabled',
  enablePushNotificationsInSettings: 'To receive notifications, please enable them in your device settings.',
  openSettings: 'Open Settings',
  pushNotificationsEnabledDescription: 'You will receive notifications on this device',
  pushNotificationsDisabledDescription: 'Enable notifications to stay updated',
  notificationCategories: 'Notification Categories',
  notificationCategoriesDescription: 'Choose what types of notifications you want to receive',
  newEpisodes: 'New Episodes',
  newEpisodesDescription: 'Get notified when new episodes are released',
  recommendations: 'Recommendations',
  recommendationsDescription: 'Personalized content suggestions for you',
  subscriptionReminders: 'Subscription Reminders',
  subscriptionRemindersDescription: 'Reminders about your subscription status',
  rewardsNotifications: 'Rewards & Achievements',
  rewardsNotificationsDescription: 'Updates about your rewards and progress',
  marketingNotifications: 'Marketing & Promotions',
  marketingNotificationsDescription: 'Special offers and promotional content',
  failedToUpdatePreferences: 'Failed to update notification preferences',
  failedToRequestPermission: 'Failed to request notification permission',
  signInToSavePreferences: 'Sign in to save your notification preferences across devices',
  done: 'Done',
  contactUs: 'Contact Us',
  settings: 'Settings',
  privacyPolicy: 'Privacy Policy',
  privacySettings: 'Privacy & Consent',
  cookieSettings: 'My Cookie Settings',
  localStorage: 'Local Storage',
  termsConditions: 'Terms & Conditions',
  legalNotice: 'Legal Notice',
  pricingConditions: 'Pricing Conditions',
  unsubscribe: 'Unsubscribe',
  unsubscribeInfo: 'Unsubscribe Information',
  loadingUnsubscribeInfo: 'Loading unsubscribe information...',
  unsubscribeContentNotAvailable: 'Unsubscribe information is not available at the moment.',
  dcbUnsubscribeButton: 'Cancel my subscription',
  dcbUnsubscribeConfirmTitle: 'Confirmation',
  dcbUnsubscribeConfirmMessage: 'Are you sure you want to cancel your subscription? You will lose access to premium content.',
  dcbUnsubscribeSuccess: 'Your subscription has been successfully cancelled. You are no longer subscribed to the service.',
  dcbUnsubscribeError: 'Unable to cancel your subscription. Please contact customer support for assistance.',
  loadingPrivacyPolicy: 'Loading privacy policy...',
  privacyPolicyNotAvailable: 'Privacy policy is not available at the moment.',
  loadingTermsConditions: 'Loading terms and conditions...',
  termsConditionsNotAvailable: 'Terms and conditions are not available at the moment.',
  cookies: 'Cookies',
  cookiesSection: 'Cookies',
  legalSection: 'Legal Information',
  loadingCookies: 'Loading cookies information...',
  cookiesNotAvailable: 'Cookies information is not available at the moment.',
  loadingLegalNotice: 'Loading legal notice...',
  legalNoticeNotAvailable: 'Legal notice is not available at the moment.',
  loadingPricingConditions: 'Loading pricing conditions...',
  pricingConditionsNotAvailable: 'Pricing conditions are not available at the moment.',
  retry: 'Retry',
  noEmailApp: 'No email application is available on this device.',
  errorOpeningEmail: 'Unable to open email application.',
  errorOpeningSettings: 'Unable to open system settings.',
  security: 'Security',
  
  // Loading and errors
  loading: 'Loading...',
  loadingContent: 'Loading content...',
  preparingVideo: 'Preparing video...',

  seasonNotFound: 'Season not found',
  episodeNotFound: 'Episode not found',
  rubriqueNotFound: 'Rubrique not found',
  
  // Video player

  loadingVideo: 'Loading video...',
  loadingPlayer: 'Loading player...',
  loadingEpisodes: 'Loading episodes...',
  
  // Badges and labels
  min: 'min',
  enemiesToLovers: 'Enemies to Lovers',
  
  // Actions
  cancel: 'Cancel',
  delete: 'Delete',
  remove: 'Remove',
  removeFromList: 'Remove from My List',
  subscribe: 'Subscribe',
  selectLanguage: 'Select Language',
  restartRequired: 'Restart Required',
  restartMessage: 'Please restart the app to apply the new layout direction.',
  restartToApplyLanguage: 'Restart the app to apply the new language?',
  ok: 'OK',
  save: 'Save',
  saving: 'Saving...',
  editProfile: 'Edit Profile',
  pseudo: 'Pseudo',
  enterPseudo: 'Enter your pseudo',
  pseudoPlaceholder: 'Choose a unique name (max 16 chars)',
  pseudoTaken: 'This pseudo is already taken',
  pseudoInvalid: 'This pseudo contains inappropriate content',
  pseudoInvalidCharacters: 'This pseudo contains invalid characters',
  pseudoNotAccepted: 'Please choose another pseudo, this one cannot be accepted',
  pseudoMaxLength: 'Pseudo must be 16 characters or less',
  pseudoCharactersCount: '{{count}}/16 characters',
  editPseudo: 'Edit pseudo',
  pseudoUpdated: 'Pseudo updated successfully',
  subtitles: 'Subtitles',
  off: 'Off',
  noSubtitlesAvailable: 'No subtitles available',
  playbackSpeed: 'Playback Speed',
  normalSpeed: 'Normal',
  profileInformation: 'Profile Information',
  dateOfBirth: 'Date of Birth',
  phoneNumber: 'Phone Number',
  enterPhoneNumber: 'Enter your phone number',
  notProvided: 'Not provided',
  dateFormatHint: 'Format: {format} (e.g., {example})',
  dateFormatPattern: 'MM-DD-YYYY',
  dateFormatExample: '12-31-1990',
  invalidDateFormat: 'Please use the format: {format}',
  invalidDate: 'Invalid date',
  
  // Placeholders and descriptions
  discoverGenre: 'Discover',
  
  // Time and duration
  m: 'M', // Million views abbreviation
  now: 'now',
  minuteAbbrev: 'm',
  hourAbbrev: 'h',
  dayAbbrev: 'd',
  monthAbbrev: 'mo',
  
  // History and viewing progress
  noViewingHistory: 'No viewing history',
  episodesWillAppearHere: 'Episodes you watch will appear here',
  history: 'History',
  series: 'Series',
  noFavoritesYet: 'No favorites yet',
  addContentToFavorites: 'Add series and episodes to your favorites to see them here',

  // My Purchases
  myPurchases: 'My Purchases',
  purchased: 'Purchased',
  myPurchasesTitle: 'Your Unlocked Episodes',
  myPurchasesDescription: 'Find here all premium episodes you have unlocked with your coins. Keep watching to earn more coins!',
  tutorialStep1Title: 'Watch episodes',
  tutorialStep1Description: 'Earn coins by watching free content on the platform.',
  tutorialStep2Title: 'Collect rewards',
  tutorialStep2Description: 'Complete challenges and log in daily to earn even more coins.',
  tutorialStep3Title: 'Unlock premium content',
  tutorialStep3Description: 'Use your coins to unlock exclusive premium episodes.',
  goToRewards: 'Go to rewards',

  // Gamification notifications
  userSignupNotification: 'Welcome! You earned {coins} coins for creating your account!',
  dailyVisitNotification: 'You earned {coins} coins for your daily visit!',
  emailProvidedNotification: 'You earned {coins} coins for providing your email!',
  msisdnProvidedNotification: 'You earned {coins} coins for providing your phone number!',
  birthDateProvidedNotification: 'You earned {coins} coins for providing your date of birth!',
  completeProfileNotification: 'You earned {coins} coins for completing your profile!',
  pseudoProvidedNotification: 'You earned {coins} coins for creating a custom pseudo!',
  selectImageSource: 'Select Image Source',
  takePhoto: 'Take Photo',
  chooseFromLibrary: 'Choose from Library',
  removeProfilePicture: 'Remove Profile Picture',
  removeProfilePictureConfirm: 'Are you sure you want to remove your profile picture?',
  profilePictureUpdated: 'Profile picture updated successfully',
  profilePictureRemoved: 'Profile picture removed successfully',
  failedToPickImage: 'Failed to select image from library',
  failedToTakePhoto: 'Failed to take photo',
  failedToUploadImage: 'Failed to upload image. Please try again.',
  imageInappropriateContent: 'Image contains inappropriate content',
  failedToUpdateProfilePicture: 'Failed to update profile picture',
  failedToRemoveProfilePicture: 'Failed to remove profile picture',
  remove: 'Remove',
  watchEpisodeNotification: 'You earned {coins} coins for watching an episode!',
  watchAdsNotification: 'You earned {coins} coins for watching ads!',
  enableNotificationsNotification: 'You earned {coins} coins for enabling notifications!',
  followSocialNotification: 'You earned {coins} coins for following us on social media!',
  coinsEarnedNotification: 'You earned {coins} coins!',
  coinsUsedForPremiumNotification: 'You used {coins} coins to unlock this premium episode!',
  firstCoinsUsageNotification: 'Welcome! You just unlocked your first premium episode with coins!',

  // Reward Center
  rewardCenter: 'Reward Center',
  rewards: 'Rewards',
  weeklyRanking: 'Weekly Ranking',
  hallOfFame: 'Hall of Fame',
  thisWeeksTopPlayers: 'This Week\'s Top Players',
  allTimeChampions: 'All-Time Champions',
  totalCoinsAllTime: 'total coins',
  coinsThisWeek: 'coins this week',
  achievements: 'achievements',
  dayStreakRecord: 'day streak',
  you: 'You',
  noRankingData: 'No ranking data available',
  checkBackLaterRanking: 'Check back later for weekly rankings',
  noHallOfFameData: 'No hall of fame data available',
  checkBackLaterHallOfFame: 'Check back later for all-time rankings',
  coins: 'Coins',
  days: 'days',
  dailyCheckIn: 'Daily Check-in',
  earnRewards: 'Earn Rewards',
  completed: 'Completed',
  claim: 'To do',
  comingSoon: 'Coming Soon',
  day: 'Day',
  today: 'Tomorrow',
  totalCoins: 'Total Coins',
  getCoins: 'Get Coins,',
  keepWatching: 'Keep Watching',
  dayStreak: 'Day Streak',
  nextReward: 'Next Reward',
  availableTomorrow: 'Available tomorrow',
  weekProgress: 'Week Progress',
  serie: 'Streak',
  won: 'Won',
  tomorrow: 'Tomorrow',
  toDo: 'To Do',
  firstWeek: 'First Week',
  secondWeek: 'Second Week',
  amazingStreak: 'Amazing streak! Keep it up!',
  overallProgress: 'Overall Progress',
  of: 'of',
  eventsCompleted: 'events completed',
  ofMissionsCompleted: 'of missions completed',

  // Gamification event categories
  gamificationCategoryUser: 'User',
  gamificationCategoryProfile: 'Profile',
  gamificationCategoryContent: 'Content',
  gamificationCategoryGeneral: 'General',
  gamificationCategoryDailyMission: 'Daily Mission',
  gamificationCategoryWelcomeMissions: 'Welcome Missions',
  gamificationCategoryWatchMissions: 'Watch Missions',
  gamificationCategoryOnceAYear: 'Once A Year',

  // Gamification Intro Modal (for guests)
  gamificationIntroSubtitle: 'Complete missions and earn coins!',
  gamificationFeature1Title: 'Create your account',
  gamificationFeature1Desc: 'Get {{coins}} welcome coins when you sign up',
  gamificationFeature2Title: 'Watch episodes',
  gamificationFeature2Desc: 'Earn {{coins}} coins for every episode you complete',
  gamificationFeature3Title: 'Climb the rankings',
  gamificationFeature3Desc: 'Compare yourself with other members every week',
  gamificationFeature4Title: 'Unlock premium episodes',
  gamificationFeature4Desc: 'Use your coins to watch even more episodes',
  gamificationBonusText: '+{{coins}} coins free when you sign up!',
  createAccount: 'Create my account',
  connectToYou: 'Log in',

  // All Episodes Control
  allEpisodes: 'All Episodes',
  watchNow: 'Watch Now',
  previousEpisode: 'Previous',
  nextEpisode: 'Next',

  // App availability
  appNotAvailable: 'This application is not yet available in your country and language.',
  appNotAvailableSubtext: 'We are working to expand our service to more regions.',
  
  // Biometric authentication
  biometricLogin: 'Biometric Login',
  signInWithBiometric: 'Sign in with biometric',
  signInWithWebAuthn: 'Sign in with WebAuthn',
  signInWithFaceId: 'Sign in with Face ID',
  signInWithTouchId: 'Sign in with Touch ID',
  enableBiometric: 'Enable biometric login',
  disableBiometric: 'Disable biometric login',
  biometricNotAvailable: 'Biometric authentication is not available on this device',
  biometricAuthFailed: 'Biometric authentication failed',
  biometricDataMissing: 'Biometric login data is missing. Please sign in with OTP, then re-enable biometric login in your profile settings.',
  biometricNoUserData: 'Please sign in first, then enable biometric login in your profile settings.',
  biometricUnexpectedError: 'An unexpected error occurred. Please sign in with OTP, then re-enable biometric login in your profile settings.',
  biometricAuthCancelled: 'Biometric authentication was cancelled. Please try again.',
  webauthnNotEnabled: 'Please sign in first, then enable WebAuthn login in your profile settings.',
  webauthnCancelled: 'WebAuthn authentication was cancelled. Please try again.',
  webauthnFailed: 'WebAuthn authentication failed',
  biometricLoginEnabled: 'Biometric login has been enabled',
  biometricLoginDisabled: 'Biometric login has been disabled',
  webauthnLoginEnabled: 'WebAuthn login has been enabled',
  webauthnLoginDisabled: 'WebAuthn login has been disabled',
  // iOS-specific labels (use branded terminology)
  faceIdLoginEnabled: 'Face ID login has been enabled',
  faceIdLoginDisabled: 'Face ID login has been disabled',
  touchIdLoginEnabled: 'Touch ID login has been enabled',
  touchIdLoginDisabled: 'Touch ID login has been disabled',
  // Android-specific labels (use generic biometric terminology)
  androidBiometricLoginEnabled: 'Biometric login has been enabled',
  androidBiometricLoginDisabled: 'Biometric login has been disabled',
  failedToEnableBiometric: 'Failed to enable biometric login',
  failedToDisableBiometric: 'Failed to disable biometric login',
  failedToEnableWebauthn: 'Failed to enable WebAuthn login',
  failedToDisableWebauthn: 'Failed to disable WebAuthn login',
  success: 'Success',
  enableBiometricPrompt: 'Enable biometric authentication for quick sign in next time?',
  enableBiometricPromptIos: 'Enable {authType} for quick sign in next time?',
  'Enable {{authType}}?': 'Enable {{authType}}?',
  'Would you like to enable {{authType}} for faster login?': 'Would you like to enable {{authType}} for faster login?',
  '{{authType}} login has been enabled!': '{{authType}} login has been enabled!',
  'Failed to enable {{authType}} login. Please try again later.': 'Failed to enable {{authType}} login. Please try again later.',
  biometricLoginTitle: 'Biometric Login',
  faceIdLogin: 'Face ID Login',
  touchIdLogin: 'Touch ID Login',
  useBiometricToSignIn: 'Use fingerprint or face unlock to sign in quickly',
  enableBiometricForSignIn: 'Enable fingerprint or face unlock for quick sign in',
  useFaceIdToSignIn: 'Use Face ID to sign in quickly',
  enableFaceIdForSignIn: 'Enable Face ID for quick sign in',
  useTouchIdToSignIn: 'Use Touch ID to sign in quickly',
  enableTouchIdForSignIn: 'Enable Touch ID for quick sign in',

  // Delete account
  deleteMyAccount: 'Delete my account',
  deleteAccountConfirmation: 'Delete confirmation',
  deleteAccountWarningNotSubscribed: 'We will proceed with deleting your account. You will no longer be able to access Hekaya after confirming.\n\nHowever, please note that in accordance with regulations, we securely retain certain data, for example for possible dispute resolution purposes.',
  deleteAccountWarningSubscribed: 'You currently have an active subscription. Please cancel it first. You will find the unsubscribe instructions in "My Account", "Unsubscribe". Once the subscription is cancelled, you can proceed with deleting your account.\n\nWe will proceed with deleting your account. You will no longer be able to access Hekaya after confirming.\n\nHowever, please note that in accordance with regulations, we securely retain certain data, for example for possible dispute resolution purposes.',
  iConfirm: 'I confirm',
  deletingAccount: 'Deleting account...',
  accountDeleted: 'Account deleted',
  accountDeletedSuccess: 'Your account has been successfully deleted',
  accountDeleteError: 'Error deleting account',
  activeSubscriptionErrorTitle: 'Active subscription',
  activeSubscriptionErrorMessage: 'You must cancel your subscription before you can delete your account.',
  gracePeriodErrorTitle: 'Deletion not possible yet',
  gracePeriodErrorMessage: 'Your subscription has been canceled, but it remains active until its expiration date. You will be able to delete your account once this period has ended.',
  gracePeriodBannerTitle: 'Subscription canceled',
  gracePeriodBannerMessage: 'Your subscription has been canceled but remains active until {{date}}. You keep access to all premium content until then.',
  notBilledDenyBannerTitle: 'Subscription suspended',
  notBilledDenyBannerMessage: 'Your subscription has been temporarily suspended due to a payment issue. To restore access to our service, please top up your account *9. Your Hekaya account will be reactivated once payment is processed.',

  // Network connection
  noInternetConnection: 'No internet connection available. Please check your connection and try again.',
  noInternetConnectionShort: 'No internet connection',
  checkInternetConnection: 'Please check your internet connection',
  connectionRequired: 'Internet connection required',
  dismiss: 'Continue offline',
  slowNetworkDetected: 'Slow network detected',
  poorNetworkConnection: 'Your network connection is experiencing issues. Video loading is taking longer than usual.',
  loadingTime: 'Loading time',
  slowConnection: 'Slow connection',
  retry: 'Retry',

  // App version
  version: 'Version',

  // Image cache
  imageCacheStorage: 'Image Cache Storage',
  cachedImages: 'Cached Images',
  storageUsed: 'Storage Used',
  expiredImages: 'Expired Images',
  clearExpiredCache: 'Clear Expired',
  clearAllCache: 'Clear All',
  clearing: 'Clearing...',
  clearImageCache: 'Clear Image Cache',
  clearImageCacheConfirmation: 'Are you sure you want to clear all cached images? This will free up storage space but images will need to be downloaded again.',
  clearCache: 'Clear Cache',
  cacheCleared: 'Cache cleared successfully! Cleared {{count}} images.',
  expiredCacheCleared: 'Expired cache cleared! Removed {{count}} expired images.',
  noExpiredCache: 'No expired images to clear.',
  failedToClearCache: 'Failed to clear cache. Please try again.',
  cacheAutoClears30Days: 'Images are automatically cleared after 30 days',
  info: 'Info',

  // Pagination
  scrollForMore: 'Scroll for more',
  noMoreContent: 'End of list',
  loadingMore: 'Loading...',

  // OTP Authentication
  otp: {
    signInOrSignUp: 'Sign in or create a free account',
    subscriptionWelcomeTitle: 'Thank you for your subscription!',
    subscriptionWelcomeMessage: 'Final step: sign up to create an account or sign in to an existing one to start watching dramas.',
    emailPlaceholder: 'Email address',
    phonePlaceholder: 'Phone number',
    emailOrPhonePlaceholder: 'Email or Phone number',
    continue: 'Continue',
    continueWithGoogle: 'Continue with Google',
    continueWithApple: 'Continue with Apple',
    termsPrefix: 'By continuing, you accept our',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    confirmEmail: 'Confirm email address',
    confirmYourEmail: 'Confirm your email address',
    confirmPhone: 'Confirm phone number',
    confirmYourPhone: 'Confirm your phone number',
    codeSentTo: 'We sent a code to',
    codeSentToPhone: 'We sent a code to',
    enterCodeBelow: 'Enter it below to verify your account.',
    resendCode: 'Resend code',
    resendIn: 'Resend in',
    verify: 'Verify',
    connectingInProgress: 'Connecting...',
    accountCreated: 'Account created',
    stayUpdatedTitle: 'Would you like to stay up to date with the latest news?',
    stayUpdatedDescription: 'We would love to send you personalized offers, inspiring content, device tips and information about our latest innovations.',
    learnMore: 'Learn more',
    subscribe: 'Subscribe',
    noThanks: 'No thanks',
    enterEmailOrPhone: 'Please enter your email or phone number',
    sendFailed: 'Failed to send code. Please try again.',
    enterCompleteCode: 'Please enter the complete 6-digit code',
    verificationFailed: 'Verification failed. Please try again.',
    invalidCode: 'Invalid code. Please try again.',
    codeExpired: 'Code has expired. Please request a new one.',
    checkSpamFolder: 'Remember to check your spam folder',
    dcbValidatingSubscription: 'Validating your subscription...',
    dcbActivating: 'Activating your subscription...',
    dcbSuccessTitle: 'Subscription activated!',
    dcbSuccessMessage: 'Your subscription has been activated successfully. You can now enjoy all content.',
    dcbStartWatching: 'Start watching',
    dcbErrorTitle: 'Activation error',
    dcbErrorRetry: 'An error occurred while activating your subscription. Please try again.',
    dcbPaymentNotFound: 'Subscription not found. Please check your link or contact support.',
    dcbRetryButton: 'Retry',
    dcbIdentityMismatchPhone: 'The phone number used for the subscription is {{identifier}}. Please use this number to create your account.',
    dcbIdentityMismatchEmail: 'The email used for the subscription is {{identifier}}. Please use this email to create your account.',
    dcbRecoveryBanner: 'A pending subscription was detected. Create your account to access it.',
    dcbAlreadySubscribed: 'Already subscribed via mobile payment?',
    dcbEnterPhone: 'Enter the phone number used during payment:',
    dcbRecoverButton: 'Recover',
    dcbMsisdnNotFound: 'No pending subscription found for this number.',
    dcbMsisdnRecoveryFailed: 'Recovery failed. Please try again.',
    invalidPhoneNumber: 'Invalid phone number.',
  },
  and: 'and',
  smartBannerSubtitle: 'Better experience in the app',
  smartBannerOpen: 'OPEN',
  paymentVerifying: 'Verifying your subscription...',
  paymentSuccessTitle: 'Subscription activated!',
  paymentSuccessMessage: 'Congratulations, you now have access to all Premium content.',
  paymentSuccessButton: 'Start watching',
  paymentPendingMessage: 'Your payment has been received. Your subscription will be active shortly.',
  paymentRefreshButton: 'Refresh',
  redirectingToPayment: 'Redirecting to payment page...',
  webPaymentIframeErrorTitle: 'Payment page unavailable',
  webPaymentIframeErrorMessage: 'The payment page could not be loaded in the app. You can open it in a new tab.',
  webPaymentOpenExternal: 'Open in a new tab',

  // Premium subscription card
  enterPremiumExperience: 'Enter the',
  popular: 'POPULAR',
  mobileInvoice: 'Mobile Invoice',
  mobileInvoicePrice: '€9.99/month',
  mobileInvoiceDescription: 'Payment on your phone bill. Simple and Fast.',
  cardAppleGooglePay: 'Card / Apple Pay / Google Pay',
  cardPaymentDescription: 'Secure payment by card, Apple Pay or Google Pay.',
  dcbPaymentOfferDescription: 'Payment on your phone bill. Simple and fast.',
  appStorePaymentTitle: 'App Store',
  appStorePaymentDescription: 'Subscription billed and managed via your Apple App Store account.',
  playStorePaymentTitle: 'Google Play',
  playStorePaymentDescription: 'Subscription billed and managed via your Google Play Store account.',
  upgradeToPremium: 'Upgrade to Premium',
  cancelAnytimeNoCommitment: 'Cancel anytime · No commitment',
  whyBecomeVip: 'Why become VIP?',
  joinPremiumCommunity: 'Join our Premium Hekaya community',
  unlimitedAccessShort: 'Access all series and episodes without limits.\nWatch whenever you want, wherever you want.',

  // DCB subscription details (profile view)
  dcbOfferDaily: 'Daily subscription',
  dcbOfferWeekly: 'Weekly subscription',
  dcbOfferMonthly: 'Monthly subscription',
  dcbOfferQuarterly: 'Quarterly subscription',
  dcbOfferYearly: 'Yearly subscription',
  dcbOfferRecurring: 'Recurring subscription',
  dcbSubscriptionValidity: 'Valid until {{date}}',
};

export type TranslationKey = keyof typeof en;